export default __webpack_public_path__ + "static/media/Ei2.0f9f4868.jpg";